import config from "../config";

/**
 * Find a user by email/mobile/username.
 */
export const getOffers = async (searchField) => {

    const response = await fetch(`${config.apiUrl}/offers`);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'User not found');
    }
    return response.json();
  };